import { createAction } from '@reduxjs/toolkit';
import type { NatalieFeedbackFormValues } from 'natalie/schemas/natalieFeedback.schema';

export const natalieActions = {
  beforeJoinPage: {
    continueButton: {
      clicked: createAction<{ id: string }>('[Before Join Natalie Event Page] continue button clicked'),
    },
  },
  detailsPage: {
    startChattingButton: {
      clicked: createAction<{ id: string }>('[Natalie Event Details Page] start chatting button clicked'),
    },
  },
  joinPage: {
    joinButton: {
      clicked: createAction<{ id: string; isMicrophoneEnabled: boolean; microphoneId: string; speakerId: string }>(
        '[Join Natalie Event Page] join button clicked'
      ),
    },
  },
  list: {
    moreActions: {
      copyLinkButtonClicked: createAction<string>('[Natalie List More Actions] copy link clicked'),
    },
  },
  room: {
    header: {
      issueReported: createAction<NatalieFeedbackFormValues>('[Natalie Room Header] issue reported'),
    },
  },
};
